<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-date-range ttRememberId="w_timesheets_status" ttLabel="date_fom_tom" ttLabelView="top" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="onDateRangeChanged()"></tt-date-range>
            <tt-input ttLabel="filtervalue" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListStatuses" ltype="multi" [filterVal]="setting.filtervalue" typevar="g"></tt-list-legacy>

        <tt-card *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="timesheets_status_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <tt-date-range ttRememberId="w_timesheets_status" ttLabel="date_fom_tom" ttLabelView="top" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="onDateRangeChanged()"></tt-date-range>
                        <tt-input ttLabel="filtervalue" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="90">
                    <tt-list-legacy [listItems]="itemsListStatuses" ltype="multi" [filterVal]="setting.filtervalue" typevar="g"></tt-list-legacy>

                    <tt-card *ngIf="setting.show_setting === '1'">
                        <tt-button-settings></tt-button-settings>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
